import $ from 'jquery'

import FlyoutBackground from '../../utils/FlyoutBackground'
import Flyout from '../../utils/Flyout'

class NavigationDesktop {
  constructor(el) {
    this.el = el
    this.items = $('.main-nav-desktop__nav-mainlinks__item', this.el)
    this.background = $('.main-nav-desktop__submenu__background', this.el)

    this.activeFlyout = null
    this.activeBackground = null

    this.init()
    this.listen()
  }

  init() {
    // init the flyouts
    this.items.each((index, item) => {
      // Uebergeben wird der Menuepunkt; den Ausloeser sucht sich das Flyout darin.
      new Flyout($(item))
    })

    // init the flyoutbackground
    this.activeBackground = new FlyoutBackground(this.background)
  }

  listen() {
    this.el.on('flyout-open', this.onFlyoutOpen.bind(this))
    this.el.on('flyout-close', this.onFlyoutClose.bind(this))
    this.el.on('flyout-resize', this.onFlyoutResize.bind(this))
  }

  onFlyoutOpen(event, flyout) {
    // close already open flyout and set the new one as active and animate the background
    if (this.activeFlyout) {
      const deactivatedFlyout = this.activeFlyout
      this.activeFlyout = flyout

      this.activeBackground.change(deactivatedFlyout.height, this.activeFlyout.height)
      deactivatedFlyout.hideFlyout()
      return
    }

    // activate the new one an show the background
    this.activeBackground.show(flyout.height)
    this.activeFlyout = flyout
  }

  onFlyoutClose(event, flyout) {
    // only reset active flyout when the closed one is the last opened one
    if (this.activeFlyout !== flyout) {
      return
    }

    this.activeBackground.hide(this.activeFlyout.height)
    this.activeFlyout = null
  }

  onFlyoutResize(event, flyout) {
    this.activeBackground.change(null, flyout.height)
  }
}

export default NavigationDesktop
